// extracted by mini-css-extract-plugin
export var focusShadow = "carousel-module--focusShadow--AxcqE";
export var shadow = "carousel-module--shadow--r97IT";
export var slide = "carousel-module--slide--jbCPW";
export var swiperButton = "carousel-module--swiperButton--5sucT";
export var swiperButtonNext = "carousel-module--swiperButtonNext--flRgR";
export var swiperButtonPrev = "carousel-module--swiperButtonPrev--ZO1AG";
export var swiperContainer = "carousel-module--swiperContainer--Y5gfl";
export var wrapper = "carousel-module--wrapper--jNw1d";